import styled from '@emotion/styled';
import React from 'react';

const DragDropArea = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    position: relative;
    transition: all 0.2s ease-in-out;
    overflow: hidden;

    ${(props) =>
        props.isDragging &&
        `
	background-color: rgba(200, 231, 232, 0.3);
	border: 3px dashed #50aeb0;
	border-radius: 12px;
	margin: 4px;
	
  `}

    .messages-container {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 0; /* Important: allows flex child to shrink below content size */
    }
    .chat-input-container {
        flex-shrink: 0;
        background-color: transparent;
        padding-bottom: 5px;
    }
`;

const DropOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: ${(props) => (props.isDragging ? 'flex' : 'none')};
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: 1000;
    pointer-events: none;
    border-radius: 12px;
`;

const DropMessage = styled.div`
    background: #e7e7e77d;
    padding: 24px 32px;
    text-align: center;
    font-size: 24px;
    color: #2e9a9c;
    font-weight: bold;
    border-radius: 12px;

    .icon {
        font-size: 48px;
        margin-bottom: 12px;
        display: block;
    }

    .subtext {
        font-size: 14px;
        color: #666;
        font-weight: normal;
        margin-top: 8px;
    }
`;

const ChatDragAndDrop = React.memo(
    ({ children, isDragging, handleDragEnter, handleDragLeave, handleDragOver, handleDrop }) => {
        return (
            <DragDropArea
                isDragging={isDragging}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
            >
                <DropOverlay isDragging={isDragging}>
                    <DropMessage>
                        <span className="icon">📁</span>
                        Drop files here to share
                        <div className="subtext">Files will be attached to your message</div>
                    </DropMessage>
                </DropOverlay>

                {children}
            </DragDropArea>
        );
    }
);

export default ChatDragAndDrop;
